import React from 'react';

export const HeaderSkeleton = () => {
  return (
    <div className="flex flex-col gap-3 py-6">
      <div className="h-4 w-2/3 min-w-[250px] animate-pulse rounded-md bg-gray-200"></div>
      <div className="h-8 w-1/3 min-w-[150px] animate-pulse rounded-md bg-gray-300"></div>
    </div>
  );
};

export default HeaderSkeleton;
